import React from 'react'
import UpdateBudgetRequest from 'src/app/UpdateBudgetRequest/UpdateBudgetRequest'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateBudgetRequestRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateBudgetRequestAppRoute: AppRoute = {
  id: AppLocation.UpdateBudgetRequest,
  routeProps: updateBudgetRequestRouteProps,
  component: <UpdateBudgetRequest />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateBudgetRequestAppRoute
